











import { defineComponent, getCurrentInstance, toRefs } from '@vue/composition-api';
import CollectInfoBrowser from '@/renderer/views/browser/collect/components/CollectInfo.vue';
import CollectInfoMobile from '@/renderer/views/mobile/collect/components/CollectInfo.vue';

export default defineComponent({
  name: 'CollectInfo',
  props: {
    collectToken: {
      type: String,
      require: true,
      default: '',
    },
  },
  components: { CollectInfoBrowser, CollectInfoMobile },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;

    const methods = {
      showLoginDialog(way: string) {
        vm.$emit('show-login-dialog', way);
      },
    };
    return {
      ...methods,
    };
  },
});
